module.exports = __webpack_public_path__ + "05_glasses_red.d6389bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer4/05_glasses_red.png
// module id = gGpG
// module chunks = 0